const menFootwearMenu = data => `
<ul>
    <li class="sectionhead w23_ftw" tabindex="1">
        <a href="/c/mens/footwear" data-linkid="footwear:mens-footwear" data-prefix="men">${data["Men's Footwear"]}</a>
    </li>
    <div class=""footwear_hike"">
        <li class="footwear_hike">
            <a href="/c/mens/footwear-hike/wid-kjyr4dq9" data-prefix="men" data-linkid="footwear:mens-footwear:mens-hike">${data["Men's Hike"]}</a>
        </li>
        <li class="footwear_climb">
            <a href="/c/mens/footwear-climb/wid-kjyr4dq9" data-prefix="men" data-linkid="footwear:mens-footwear:mens-climb">${data["Men's Climb"]}</a>
        </li>
        <li class="footwear_run">
            <a href="/c/mens/footwear-run/wid-kjyr4dq9" data-prefix="men" data-linkid="footwear:mens-footwear:mens-run">${data["Men's Run"]}</a>
        </li>
    </div>
</ul>
`;

const womenFootwearMenu = data => `
<ul>
    <li class="sectionhead w23_ftw" tabindex="1">
        <a href="/c/womens/footwear" data-linkid="footwear:womens-footwear" data-prefix="women">${data["Women's Footwear"]}</a>
    </li>
    <div class="footwear">
        <li class="footwear_hike">
            <a href="/c/womens/footwear-hike/wid-kjyr4dq9" data-prefix="women" data-linkid="footwear:womens-footwear:womens-hike">${data["Women's Hike"]}</a>
        </li>
        <li class="footwear_climb">
            <a href="/c/womens/footwear-climb/wid-kjyr4dq9" data-prefix="women" data-linkid="footwear:womens-footwear:womens-climb">${data["Women's Climb"]}</a>
        </li>
        <li class="footwear_run">
            <a href="/c/womens/footwear-run/wid-kjyr4dq9" data-prefix="women" data-linkid="footwear:womens-footwear:womens-run">${data["Women's Run"]}</a>
        </li>
    </div>
</ul>
`;

export const shopMoreMenu = data => `<ul class="shopmore">
        <li class="sectionhead shop-more" tabindex="1">
            <span data-prefix="women">${data["$^nav-ShopMore^$"]}</span>
        </li>
        <div class="mobilefly">
            <li class="mobilehead">
                <span data-prefix="women">${data["$^nav-ShopMore^$"]}</span>
            </li>
            <li class="footwear_climb">
                <a href="/shop/footwear/" data-prefix="women" data-linkid="footwear:shop-more:footwear-innovation">${data["Footwear Innovation"]}</a>
            </li>
            <li class="f23_footwear_finder">
                <a href="/shop/footwear-finder" data-prefix="women" data-linkid="footwear:shop-more:footwear-finder">${data["$^nav-footwearFinder^$"]}</a>
            </li>
            <li class="obsessive-design">
                <a href="/explore/obsessive-design/films/" data-linkid="footwear:shop-more:obsessive-design">${data["Obsessive Design"]}</a>
            </li>
        </div>
    </ul>`;

const footwearShoppingCategoryMenusFdp = data => `
    <ul class="footwear">
        ${menFootwearMenu(data)}
        ${womenFootwearMenu(data)}
        <div class="nav-item__divider_footwear"></div>
        ${shopMoreMenu(data)}
    </ul>
 
`;

export const footwearShoppingCategoryMenu = data => footwearShoppingCategoryMenusFdp(data);
